import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StatementDataBuilder } from './statement-data.builder';
import { StatementDataDispatcher } from './statement-data.dispatcher';
import { StatementDataEffects } from './statement-data.effects';
import { FEATURE_NAME, reducer } from './statement-data.reducer';
import { StatementDataService } from './statement-data.service';
import { StatementDataStore } from './statement-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([StatementDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [],
})
export class StatementDataModule {
  static forRoot(): ModuleWithProviders<StatementDataModule> {
    return {
      ngModule: StatementDataModule,
      providers: [
        StatementDataBuilder,
        StatementDataService,
        StatementDataDispatcher,
        StatementDataStore,
      ],
    };
  }
}
